import { render } from "./LocumIAM.vue?vue&type=template&id=8ab29aa4"
import script from "./LocumIAM.vue?vue&type=script&lang=js"
export * from "./LocumIAM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__